export const environment = {
  baseUrl: 'https://dev-cp-api.renewams.com',
  rumApplicationId: '587c4ae9-5dbe-492a-bd0e-7aa25d2556bd',
  production: false
}
